// src/firebaseConfig.js
import firebase from "firebase";

// Your web app's Firebase configuration
var firebaseConfig = {
    apiKey: "AIzaSyA7WeLcE01SR-1hbuFX2ZEOuyci7RLDGi4",
    authDomain: "semanggi-app-a6d13.firebaseapp.com",
    databaseURL: "https://semanggi-app-a6d13-17f97.firebaseio.com/",
    storageBucket: "semanggi-app-a6d13.appspot.com",
    messagingSenderId: "35426065623",
};

// Initialize Firebase
export default firebase.initializeApp(firebaseConfig);